<template>
  <div>
    <el-row class="tac">
      <el-col :span="6"> <h3 style="margin-left: 30px">后台管理系统</h3></el-col>
      <el-col :span="2" :offset="16">  <el-link type="danger" style="margin-top: 20px" @click.native="goDown">回到首页</el-link>
       </el-col>

      </el-row>

      <el-row class="tac">
      <el-col :span="3">
            <el-menu
            default-active="1"
            class="el-menu-vertical-demo"
            router
            >
          <el-menu-item index="a" >
            <i class="el-icon-user"></i>
            <span slot="title">用户管理</span>
          </el-menu-item>


          <el-submenu index="3">
            <template slot="title"><i class="el-icon-edit-outline"></i>下载资料</template>
            <el-menu-item index="xueke">学科门类</el-menu-item>
            <el-menu-item index="ziliao">资料管理</el-menu-item>
          </el-submenu>

          <el-menu-item index="4">
            <i class="el-icon-setting"></i>
            <span slot="title">个人中心</span>
          </el-menu-item>

        </el-menu>
      </el-col>

      <el-col :span="16" >
        <router-view>
        </router-view>
      </el-col>




    </el-row>

  </div>
</template>

<script>
import http from "@/utils/http-base";

export default {
  name: "admin",
  methods:{
    goDown(){
      this.$router.push({
        name:'index2',
      }).catch(()=>{})

    },
    checkLogin() {
      http.get("/api/login/").then(res=>{
        if (res.data.code!==0){
          this.$router.push({
            name:'index',
          })
        }else if (!res.data.data.IsAdmin){
          this.$router.push({
            name:'index',
          })
        }
      })
    },
  },
  mounted() {
    this.checkLogin()
  }
}
</script>

<style scoped>

</style>